import React, { useEffect } from 'react'
import { useSelector } from 'react-redux'
import ObserverEmitter, { EVENTS } from '../../../emitter/Observer'
import { DialogBar } from '../../../components/common/DialogBar'

export const SubtopicTwo = () => {
	const { loaded } = useSelector(state => state.menu)

	useEffect(() => {
		if (loaded) {
			ObserverEmitter.emit(EVENTS.subtopicTwo.initScene, 0);
		}
	}, [loaded])
	return (
		<>
			<DialogBar
				callback={() => { }}
				dialog={"vienvenido subtema 2"}
				percentage={"100%"}
			></DialogBar>
		</>
	)
}
